import React from 'react';
import { Badge } from 'react-bootstrap';
import { sessionStatusClass } from './sessionStatus';

// Shared AG Grid "status" column cell renderer. Used by every live session-status surface
// (debugger/sessions list, debugger/session select modal, ...) so the status->class mapping is
// defined once (sessionStatusClass) instead of being re-hardcoded per surface. AgGridReact does
// not render meaningfully under jsdom, so this is exported and tested directly rather than by
// mounting the grid.
export function sessionStatusCellRenderer(params) {
  return ( <Badge className={sessionStatusClass(params.value)}>{params.value}</Badge> );
}
